import { createSlice } from '@reduxjs/toolkit';
import { fetchRecurringMeetingsList } from './actions';
const initialState = {
  recurringMeetings: [],
  isPreviousMeetingsMenuOpen: false
};
const recurringMeetings = createSlice({
  name: 'recurringMeetings',
  initialState,
  reducers: {
    togglePreviousMeetingsMenuOpen: (state, action) => {
      state.isPreviousMeetingsMenuOpen = action.payload || !state.isPreviousMeetingsMenuOpen;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchRecurringMeetingsList.fulfilled, (state, action) => {
      state.recurringMeetings = action.payload.results;
    });
  }
});
export const recurringMeetingsActions = recurringMeetings.actions;
export default recurringMeetings.reducer;